// extracted by mini-css-extract-plugin
module.exports = {"container":"userMenu_container__2C6X5","avatar":"userMenu_avatar__3E9eT","button":"userMenu_button__1E5n_","focus":"userMenu_focus__1EkTK"};